import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../theme';
export const Text = forwardRef(({ as = 'p', variant = 'body', size, weight, color = 'inherit', truncate = false, center = false, className, style, children, ...props }, ref) => {
    const theme = useTheme();
    const Component = as;
    const getVariantStyles = () => {
        const variantStyles = {
            body: {
                fontSize: theme.typography.fontSize.body,
                fontWeight: theme.typography.fontWeight.normal,
                lineHeight: theme.typography.lineHeights.normal,
            },
            heading: {
                fontSize: theme.typography.fontSize.h5,
                fontWeight: theme.typography.fontWeight.bold,
                lineHeight: theme.typography.lineHeights.snug,
            },
            subheading: {
                fontSize: theme.typography.fontSize.h6,
                fontWeight: theme.typography.fontWeight.semibold,
                lineHeight: theme.typography.lineHeights.snug,
            },
            caption: {
                fontSize: theme.typography.fontSize.small,
                fontWeight: theme.typography.fontWeight.normal,
                lineHeight: theme.typography.lineHeights.normal,
            },
            overline: {
                fontSize: theme.typography.fontSize.caption,
                fontWeight: theme.typography.fontWeight.bold,
                lineHeight: theme.typography.lineHeights.normal,
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
            },
        };
        return variantStyles[variant];
    };
    const getTextColor = () => {
        const colorMap = {
            primary: theme.colors.primary,
            secondary: theme.colors.textSecondary,
            error: theme.colors.error,
            success: theme.colors.success,
            warning: theme.colors.warning,
            inherit: 'inherit',
        };
        return colorMap[color];
    };
    const textStyles = {
        margin: 0,
        fontFamily: theme.typography.fontFamily,
        color: color === 'inherit' ? theme.colors.text : getTextColor(),
        textAlign: center ? 'center' : 'left',
        overflow: truncate ? 'hidden' : 'visible',
        textOverflow: truncate ? 'ellipsis' : 'clip',
        whiteSpace: truncate ? 'nowrap' : 'normal',
        ...getVariantStyles(),
        ...(size && { fontSize: theme.typography.fontSize[size] }),
        ...(weight && { fontWeight: theme.typography.fontWeight[weight] }),
        ...style,
    };
    return (_jsx(Component, { ref: ref, className: className, style: textStyles, ...props, children: children }));
});
Text.displayName = 'Text';
